// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"194":"user-panel","289":"administration","996":"info"}[chunkId] || chunkId) + "." + {"194":"a67c0d6c","289":"5acd921a","557":"a1565bc4","790":"f0934b44","996":"b2ba76ac"}[chunkId] + ".chunk.js";
};